<template>
  <div>
    <div class="row row--grid">
      <a v-for="item in posts"
           :href="item.link"
           class="col col-sm-12 col-md-12 col-lg-4 m-news_teasers__item">
        <span class="m-news_teasers__item-date title--small font-color-primary">{{dateToLocale(item.date)}}</span>
        <p class="h4 m-news_teasers__item-title"><strong>{{ item.post_title }}</strong></p>

        <p class="m-news_teasers__item-lead" v-if="item.lead">
          {{item.lead}}
        </p>

        <v-icon name="arrow-right-color"></v-icon>
      </a>
    </div>

    <div class="action__container action__container--center">
      <button class="action action--button"
               v-if="lexicon.hasOwnProperty('show_more') && !no_more_posts"
               @click="loadMore">
        <span class="action__text">{{lexicon.show_more}}</span>
      </button>
    </div>
  </div>
</template>

<script>
import VIcon from "../VIcon/vue-icon.vue"
import { ContentLoader } from "vue-content-loader";
import {getPosts, getTerms, getLexicon} from "../rest-service/rest-service";
export default {
  name: "VNews",
  components: {
    VIcon
  },
  data () {
    return {
      offset: 12,
      post_per_page: 13,
      posts: [],
      lexicon: {},
      no_more_posts: false
    }
  },

  created() {
    getLexicon(this.lang,(response) => {
      this.lexicon = response.data;
    })
  },

  computed: {
    lang () {
      return document.documentElement.lang.split('-')[0]
    },
  },

  methods: {
    loadMore () {
      getPosts({
        post_type : 'news',
        post_status : 'publish',
        offset: this.offset,
        posts_per_page : this.post_per_page,
        orderby: 'date',
        order: 'DESC',
        suppress_filters: 0,
        lang: this.lang
      }, (response) => {

        //console.log(response.data)
        this.posts = [...this.posts, ...response.data.slice(0, 12)]

        if (response.data.length < 7) {
          this.no_more_posts = true
        }

        this.offset += this.post_per_page - 1
      })
    },

    dateToLocale (date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return (new Date(date)).toLocaleDateString('de-DE', options);

    }
  }
}
</script>
